import { useQuery } from 'react-query';
import { taxonService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useFetchTaxonWithProducts = (taxonSlug: string) => {
  return useQuery(
    `${ServerStateKeysEnum.taxonSlug}-${taxonSlug}`,
    () => {
      return taxonService.getProductsByTaxonSlug(taxonSlug);
    },
    {
      staleTime: Infinity,
      enabled: taxonSlug.length > 0,
    }
  );
};
